import { __read, __spreadArray } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/picker-view/picker-view.tsx
 */
import React, { createContext, useEffect, useMemo, useRef } from "react";
import classNames from "classnames";
import { parseStyleText } from "../../../_util/parse-style-text";
import { noop } from "../../../_util/noop";
import { createEvent } from "../_util/create-event";
export var PickerViewContext = createContext({});
export var PickerView = React.forwardRef(function PickerView(_a, ref) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, _c = _a.onChange, onChange = _c === void 0 ? noop : _c, onPickStart = _a.onPickStart, onPickEnd = _a.onPickEnd, className = _a.className, style = _a.style, children = _a.children, indicatorClass = _a.indicatorClass, indicatorStyleText = _a.indicatorStyle;
    var valueRef = useRef([]);
    var pickingSetRef = useRef(new Set());
    var indicatorStyle = useMemo(function () { return parseStyleText(indicatorStyleText); }, [
        indicatorStyleText,
    ]);
    useEffect(function () {
        valueRef.current = __spreadArray([], __read((value || [])));
    }, [value]);
    return (React.createElement("div", { ref: ref, className: classNames("tea-core-picker__view", className), style: style }, React.Children.map(children, function (child, index) {
        return (React.createElement(PickerViewContext.Provider, { value: {
                value: value[index],
                onChange: function (colValue, _a) {
                    var event = _a.event;
                    valueRef.current[index] = colValue;
                    onChange(createEvent(event, { value: __spreadArray([], __read(valueRef.current)) }));
                },
                indicatorClass: indicatorClass,
                indicatorStyle: indicatorStyle,
                onPickStart: function (event) {
                    if (pickingSetRef.current.size <= 0) {
                        onPickStart(event);
                    }
                    pickingSetRef.current.add(index);
                },
                onPickEnd: function (event) {
                    pickingSetRef.current.delete(index);
                    if (pickingSetRef.current.size <= 0) {
                        onPickEnd(event);
                    }
                },
            } }, child));
    })));
});
//# sourceMappingURL=PickerView.js.map